import { ActionMenu, Button, CheckBox, icons } from '@portal/components'
import React, { useCallback, useMemo } from 'react'

import { useAnalytics } from '../../hooks'
import { useCollectionFilterSettings } from '../../store'
import { useDQLEditorContext } from '../dqlEditor/context'

const { Filter } = icons

export default function CollectionFilterMenu() {
  const { logEvent } = useAnalytics()
  const { appCollections } = useDQLEditorContext()
  const {
    hideEmptyCollections,
    toggleHideEmptyCollections,
    hideInternalCollections,
    toggleHideInternalCollections,
  } = useCollectionFilterSettings()

  const hasInternalCollections = useMemo(
    () => appCollections?.some((collection) => collection.startsWith('__')),
    [appCollections],
  )

  const handleHideInternalCollections = useCallback(() => {
    toggleHideInternalCollections()

    logEvent('toggleHideInternalCollections', {
      hideInternalCollections,
    })
  }, [hideInternalCollections, logEvent, toggleHideInternalCollections])

  return (
    <ActionMenu
      align="start"
      items={[
        {
          id: 'hide-empty-collections',
          render: () => (
            <CheckBox
              label="Hide empty collections"
              checked={hideEmptyCollections}
              onChange={toggleHideEmptyCollections}
              className="px-2 py-1"
            />
          ),
        },
        // Only show the internal collections filter if there are internal collections to hide
        ...(hasInternalCollections
          ? [
              {
                id: 'hide-internal-collections',
                render: () => (
                  <CheckBox
                    label="Hide internal collections"
                    checked={hideInternalCollections}
                    onChange={handleHideInternalCollections}
                    className="px-2 py-1"
                  />
                ),
              },
            ]
          : []),
      ]}
      trigger={
        <Button
          className="text-foreground-subtle"
          variant="ghost"
          size="square"
        >
          <Filter className="size-4" />
        </Button>
      }
    />
  )
}
